import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import { useHistory } from 'react-router-dom';
import { useUserState } from '@/components/context/UserContext';
import RecommendationRegistrationButton from './RecommendationRegistrationButton';
import { recommendationRouteId } from './recommendationRouteId';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';

const dateText = (value) => value ? String(value).slice(0, 10) : '–';

const detailsPath = (row) =>
  `/userAccount/doctor-recommendations/details/${row.e025Id}/${recommendationRouteId(row)}`;

export default function DoctorRecommendationsPage() {
  const history = useHistory();
  const userState = useUserState();
  const { get, response } = useFetch('/UserAccount/DoctorRecommendations');
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    get(`?espbiEsi=${encodeURIComponent(userState.espbiEsi ?? '')}`)
      .then((result) => {
        if (!active) return;
        setRecommendations(response.ok && Array.isArray(result) ? result : []);
        setError(!response.ok);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });
    return () => { active = false; };
  }, [userState.espbiEsi]);

  const openDetails = (row) => history.push(detailsPath(row), {
    recommendation: row,
    relatedRecommendations: recommendations.filter((item) => item.e025Id === row.e025Id),
  });
  const columns = [
    {
      accessorKey: 'serviceTitle',
      header: ({ column }) => <DataTableColumnHeader column={column} title="REKOMENDACIJA" />,
      cell: ({ row }) => <span className="font-medium">{row.original.serviceTitle}</span>,
    },
    {
      id: 'recommendedDate',
      accessorFn: (row) => row.recommendation?.plannedDate,
      header: ({ column }) => <DataTableColumnHeader column={column} title="REKOMENDUOJAMA DATA" />,
      cell: ({ row }) => <span className="text-muted-foreground">{dateText(row.original.recommendation?.plannedDate)}</span>,
    },
    {
      id: 'actions',
      header: '',
      cell: ({ row }) => (
        <div className="flex justify-end">
          <RecommendationRegistrationButton recommendation={row.original} />
        </div>
      ),
    },
  ];

  return (
    <div className="w-full h-full">
      {error && <p role="alert" className="px-4 py-2">Nepavyko gauti gydytojų rekomendacijų.</p>}
      <DataTable
        title="Gydytojų rekomendacijos"
        loading={loading}
        columns={columns}
        data={recommendations}
        filterableColumns={['serviceTitle', 'recommendedDate']}
        onRowClick={openDetails}
      />
    </div>
  );
}
